import StoreModule from "@/utils/StoreModule";

const hrGetSetting = StoreModule("/hr/setting/get-setting/hr");

export default hrGetSetting;
